import { FilterField, FilterValues, SearchType } from '../types';
import { maskCpfOrCnpj, unmaskCpfOrCnpj } from '../../../services/masks';

const DOCUMENT_TYPE_VALUES = new Set(['document', 'property_document', 'cpf', 'cnpj']);

export const isDocumentSearchType = (type?: SearchType): boolean => {
  if (!type) return false;
  if (type.digitsOnly === true) return true;
  return DOCUMENT_TYPE_VALUES.has(type.value);
};

export const maskDocumentSearchValue = (value: string): string =>
  maskCpfOrCnpj(value);

export const unmaskDocumentSearchValues = (
  values: FilterValues,
  fields: FilterField[]
): FilterValues => {
  let next = values;

  fields.forEach(field => {
    if (field.kind !== 'search') return;

    const typeName = field.typeName || 'type';
    const argumentName = field.argumentName || 'argument';
    const selected =
      field.types.find(type => type.value === values[typeName]) || field.types[0];

    if (!isDocumentSearchType(selected)) return;

    const current = String(values[argumentName] || '');
    const unmasked = unmaskCpfOrCnpj(current);
    if (unmasked === current) return;

    if (next === values) next = { ...values };
    next[argumentName] = unmasked;
  });

  return next;
};
